import RecurlyGiftCardPayForm from './RecurlyGiftCardPayForm';

export default RecurlyGiftCardPayForm;
